import { render, staticRenderFns } from "./ranking_deli.vue?vue&type=template&id=38aa71be&scoped=true&"
import script from "./ranking_deli.vue?vue&type=script&lang=js&"
export * from "./ranking_deli.vue?vue&type=script&lang=js&"
import style0 from "./ranking_deli.vue?vue&type=style&index=0&id=38aa71be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa71be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VChip,VCol,VContainer,VDivider,VRow,VTextField,VTextarea})
